// src/constants/colors.js
const colors = {
  // Gradients
  gradientPrimary: 'linear-gradient(180deg, #60A5FA 0%, #2563EB 100%)', // light → dark blue
  gradientHover: 'linear-gradient(180deg, #3B82F6 0%, #1D4ED8 100%)',   // hover gradient
newGradientSidebar: 'linear-gradient(180deg, #2563EB 0%, #60A5FA 100%)',
  // Sidebar
  sidebarBg: 'rgba(59, 130, 246, 0.85)', // glassy light blue
  sidebarText: '#FFFFFF',                 // white text
  sidebarHover: 'linear-gradient(180deg, #1D4ED8 0%, #3B82F6 100%)', // hover dark gradient
  sidebarHoverText: '#FFFFFF',           // keep hover text white

  // Card
  cardShadow: 'rgba(0, 0, 0, 0.3)',      // soft shadow
  cardBg: '#102A68',                     // card background

  // Buttons & Borders
  buttonGradient: 'linear-gradient(135deg, #1E40AF 0%, #2563EB 100%)',
  borderColor: '#1E3A8A',               // clean blue border

  // NEW: Basic primary & text colors
  primary: '#2563EB',                    // primary blue background
  primaryText: '#FFFFFF',                // white text for contrast
  secondary: '#1E40AF',                  // darker blue secondary background
  secondaryText: '#E0E7FF',              // light text for secondary bg
  grayLight: '#F3F4F6',                  // light gray background
  grayDark: '#1F2937',                   // dark gray text
};

export default colors;
